import { SquareStack } from 'lucide-react';

const Interstitial = () => (
  <div data-testid="interstitial-page">
    <div className="mb-6">
      <h1 className="font-heading text-3xl font-bold text-text-primary mb-1">Interstitial Ads</h1>
      <p className="font-body text-text-secondary">Full-screen ads between content transitions</p>
    </div>
    <div className="bg-white rounded-2xl border border-surface-border p-12 flex flex-col items-center justify-center text-text-muted">
      <SquareStack size={48} className="mb-4 opacity-40" />
      <p className="font-body text-lg font-medium">Coming Soon</p>
      <p className="font-body text-sm mt-1">Interstitial ad management will be available in a future update.</p>
    </div>
  </div>
);

export default Interstitial;
